import React from 'react';
import Members from '../members/members.jsx'

const Projects = () => {
    return (
        <div>
            <Members />
        </div>
    );
};

export default Projects;